/** How a work order's `isAdaptation` was decided. Stored as text. */
export enum AdaptationSource {
	/** An external field stated it. */
	FIELD = 'field',
	/** It was inferred from other facts. */
	DERIVED = 'derived',
}

/** Where an original Veeva code came from. Stored as text. */
export enum OriginalCodeSource {
	EXTERNAL = 'external',
	MANUAL = 'manual',
}

/** Where a work order's related link came from. Stored as text. */
export enum WorkOrderLinkSource {
	/** Mirrored from the external system on every sync: a person cannot edit it. */
	EXTERNAL = 'external',
	/** Added by a person in ATLAS: the sync never touches it. */
	MANUAL = 'manual',
}

/** The currency a money value takes when none is given. */
export const DEFAULT_CURRENCY = 'USD'

/** The most original codes one work order holds. */
export const MAX_ORIGINAL_CODES = 20

/** The longest original code accepted. */
export const MAX_ORIGINAL_CODE_LENGTH = 64
